import { __decorate } from "tslib";
import React, { Component } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { $l } from '../locale-context';
import Icon from '../icon';
import Button from '../button';
import autobind from '../_util/autobind';
import EventManager from '../_util/EventManager';
export default class VerifySlider extends Component {
    constructor() {
        super(...arguments);
        /**
         * 初始数据
         */
        /** x */
        this.x1 = 0;
        this.x2 = 0;
        /** 鼠标是否按下 */
        this.isMousedown = false;
        /** 是否已经成功 */
        this.isSuccess = false;
        /** 最大滑动距离 */
        this.max = 290;
        this.contentOnRef = (ele) => {
            this.contentEle = ele;
        };
        this.slideOnRef = (ele) => {
            this.slideEle = ele;
        };
        this.barOnRef = (ele) => {
            this.barEle = ele;
        };
        this.tipOnRef = (ele) => {
            this.tipEle = ele;
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    get prefixCls() {
        const { context } = this;
        return context.getProPrefixCls('secret-field');
    }
    handleMouseDown(e) {
        if (this.isSuccess) {
            return;
        }
        this.x1 = e.nativeEvent.x || e.touches[0].clientX;
        this.isMousedown = true;
        if (!this.moveEvent) {
            this.moveEvent = new EventManager(this.contentEle);
        }
        this.moveEvent
            .addEventListener('mousemove', this.handleMouseMove)
            .addEventListener('mouseup', this.handleMouseUp);
    }
    handleMouseMove(e) {
        const { onSuccess } = this.props;
        if (!this.isMousedown || this.isSuccess) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.x2 = e.x || e.touches[0].clientX;
        let diff = this.x2 - this.x1;
        if (diff < 0) {
            diff = 0;
        }
        // mouseUp时候判断
        if (diff >= this.max) {
            diff = this.max;
            this.isSuccess = true;
            this.tipEle.style.opacity = 1;
            if (onSuccess) {
                onSuccess();
            }
        }
        const { style } = this.slideEle;
        const { style: barEleStyle } = this.barEle;
        style.transform = `translateX(${diff}px)`;
        style.opacity = 1;
        style.transitionDuration = '0s';
        barEleStyle.transform = `translateX(${diff}px)`;
    }
    handleMouseUp() {
        if (this.isSuccess) {
            return;
        }
        this.isMousedown = false;
        const { style } = this.slideEle;
        const { style: barEleStyle } = this.barEle;
        style.transform = `translateX(0)`;
        style.opacity = 0;
        barEleStyle.transform = `translateX(0)`;
        if (this.moveEvent) {
            this.moveEvent
                .removeEventListener('mousemove', this.handleMouseMove)
                .removeEventListener('mouseup', this.handleMouseUp);
        }
    }
    /** 滑块取消 */
    handleSlider() {
        const { onCancel } = this.props;
        if (onCancel) {
            onCancel();
        }
    }
    componentWillUnmount() {
        this.moveEvent?.clear();
    }
    render() {
        const { prefixCls } = this;
        return (React.createElement("div", { className: `${prefixCls}-verify-content` },
            React.createElement("div", { className: `${prefixCls}-verify-content-slide`, ref: this.contentOnRef },
                React.createElement("div", { className: `${prefixCls}-simple-verify` },
                    React.createElement("div", { className: `${prefixCls}-simple-verify-tips` }, $l('SecretField', 'verify_slider_hint')),
                    React.createElement("div", { className: `${prefixCls}-simple-verify-box` },
                        React.createElement("div", { className: `${prefixCls}-simple-verify-slide`, ref: this.slideOnRef })),
                    React.createElement("div", { className: `${prefixCls}-simple-verify-bar`, onMouseDown: this.handleMouseDown },
                        React.createElement("div", { className: `${prefixCls}-simple-verify-bar-icon`, ref: this.barOnRef })),
                    React.createElement("div", { className: `${prefixCls}-simple-verify-success-tips`, ref: this.tipOnRef },
                        React.createElement(Icon, { type: 'check_circle_outline-o' }),
                        $l('SecretField', 'verify_finish')))),
            React.createElement("div", { className: `${prefixCls}-verify-content-btn` },
                React.createElement(Button, { onClick: this.handleSlider }, $l('SecretField', 'cancel')))));
    }
}
VerifySlider.displayName = 'VerifySlider';
__decorate([
    autobind
], VerifySlider.prototype, "handleMouseDown", null);
__decorate([
    autobind
], VerifySlider.prototype, "handleMouseMove", null);
__decorate([
    autobind
], VerifySlider.prototype, "handleMouseUp", null);
__decorate([
    autobind
], VerifySlider.prototype, "handleSlider", null);
